import { Navigate, useSearchParams } from 'react-router';

import { TokenTypeCode } from '@/services/types';
import { ServiceErrorCode } from '@/services/utils/service-error';
import { decodeJwt } from '@/utils/jwt-utils';

import { ResetPassword } from './reset-password';

export default function ResetPasswordCompletePage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const email = searchParams.get('email') ?? '';

  if (!token || !email) {
    return <Navigate to="/reset-password/request" replace />;
  }

  const decodedToken = decodeURIComponent(token);
  const decodedEmail = decodeURIComponent(email);

  /**
   * Skyline signs the token with a secret. If the token is malformed,
   * it will not be able to verify the signature.
   */
  const decoded = decodeJwt<{ resetToken: string }>(decodedToken);
  if (!decoded?.resetToken) {
    const params = new URLSearchParams({
      token,
      email,
      type: TokenTypeCode.RES_PWD,
      errorCode: ServiceErrorCode.InvalidToken,
    }).toString();
    return <Navigate to={`/verify/error?${params}`} replace />;
  }

  const { resetToken } = decoded;

  return <ResetPassword token={resetToken} email={decodedEmail} />;
}
